import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface WidgetPaymentResponse {
  success: boolean;
  data: {
    person: any;
    res: any[];
    banks: Record<string, string>;
  };
}

@Injectable({
  providedIn: 'root'
})
export class WidgetPaymentsService {
  private baseUrl = environment.BASE_LA;

  constructor(private http: HttpClient) {}

  getPaymentHistory(personId: string, token: string): Promise<WidgetPaymentResponse> {
    const params = new HttpParams().set('token', token);
    const headers = { 'X-Skip-Auth-Interceptor': 'true' };

    return lastValueFrom(
      this.http.get<WidgetPaymentResponse>(
        `${this.baseUrl}/api/widget/payments/person/${personId}`,
        { params, headers }
      )
    );
  }
}
